import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import menu from './MenuReducer';
import collections from './CollectionsReducer';
import videos from './VideosReducer';
import about from './AboutReducer';
import categories from './CategoriesReducer';
import celebrities from './CelebritiesReducer';
// import logger from 'redux-logger';

const store = createStore(
    combineReducers({
        menu,
        collections,
        videos,
        about,
        categories,
        celebrities
    }),
    applyMiddleware(thunk)
);

export default store;



// WEBPACK FOOTER //
// ./src/reducers/RootReducer.js